<script setup lang="ts">
// Casca da área administrativa, separada da área do cliente por decisão de produto.
</script>

<template>
  <div class="area area--admin">
    <header>
      <h1>Plataforma RFID — administração</h1>
    </header>
    <main>
      <RouterView />
    </main>
  </div>
</template>
